"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Users = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M8,18 L5,18 C4.44771525,18 4,17.5522847 4,17 C4,14.436 5.609,12.246 7.873,11.388 C6.748,10.68 6,9.428 6,8 C6,5.791 7.791,4 10,4 C11.106,4 12.107,4.448 12.831,5.174 C13.201,5.061 13.593,5 14,5 C16.209,5 18,6.791 18,9 C18,10.428 17.253,11.68 16.128,12.388 C18.391,13.246 20,15.436 20,18 L20,19 C20,19.5522847 19.5522847,20 19,20 L9,20 C8.44771525,20 8,19.5522847 8,19 L8,18 Z M10,5 C8.343,5 7,6.343 7,8 C7,9.307 7.835,10.417 9,10.829 L9,12.1 C6.718,12.564 5,14.581 5,17 L8.083,17 C8.439,14.877 9.91,13.133 11.873,12.388 C10.748,11.68 10,10.428 10,9 C10,7.586 10.734,6.343 11.842,5.632 C11.334,5.236 10.695,5 10,5 Z M13,11.829 L13,13.1 C10.718,13.564 9,15.581 9,18 L9,19 L19,19 L19,18 C19,15.581 17.282,13.564 15,13.1 L15,11.829 C16.165,11.417 17,10.307 17,9 C17,7.343 15.657,6 14,6 C12.343,6 11,7.343 11,9 C11,10.307 11.835,11.417 13,11.829 Z" })));
};
Users.displayName = 'Users';
exports.default = Users;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Users.js.map